import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M12.075 21.342a1 1 0 0 1-.72-.275q-.289-.276-.288-.725v-1.2q-1.276-.225-2.146-.917a4.96 4.96 0 0 1-1.388-1.767q-.216-.39.021-.854a1.42 1.42 0 0 1 .704-.67q.391-.117.809.033.416.15.733.616.417.709 1.05 1.034t1.4.325q1.067 0 1.692-.463.624-.463.625-1.27 0-.885-.663-1.442-.662-.559-2.554-1.134-1.867-.54-2.763-1.6-.895-1.057-.895-2.541 0-1.384.862-2.388.863-1.004 2.513-1.287V3.642q0-.434.287-.709.288-.275.721-.275.442 0 .72.275a.95.95 0 0 1 .28.709v1.175a6 6 0 0 1 1.638.625q.77.433 1.279 1.166.25.385.079.85-.17.466-.68.675-.34.142-.762.017-.42-.125-.854-.508a2.57 2.57 0 0 0-1.742-.65q-1.017 0-1.508.391a1.26 1.26 0 0 0-.492 1.042q0 .716.575 1.217.576.5 2.659 1.125 1.791.591 2.7 1.658t.941 2.7q-.008 1.725-1.012 2.75t-2.821 1.308v1.159q0 .45-.292.725a1 1 0 0 1-.708.275" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }